<div *ngIf="!displaySubmitButton" class="feedback-placeholder w-100">
  <label class="quicksand-normal-label">
    {{ feedbackText ? feedbackText : 'Add your feedback here' }}
  </label>
</div>

<textarea
  *ngIf="displaySubmitButton"
  placeholder="Add your feedback here"
  [ngClass]="{ 'full-height-textarea': isAssignmentAssessment }"
  class="w-100 p-3 quicksand-normal-label feedback-textarea"
  [(ngModel)]="feedbackText"
  cdkTextareaAutosize
  ngxTextareaAutoresize
  #autosize="cdkTextareaAutosize"
  mat-autosize="true"
  [cdkAutosizeMinRows]="3"
></textarea>
<div
  class="d-flex justify-content-end mt-2"
  [ngClass]="{ 'full-width-button': isAssignmentAssessment }"
  *ngIf="displaySubmitButton"
>
  <button nbButton class="text-capitalize quicksand-bold-label save-btn cursor-pointer" (click)="submitFeedback()">
    submit
  </button>
</div>
